module.exports = __webpack_public_path__ + "img/1.32c3d599.webp";